var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M61 32H4","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M38 55l23-23L38 9","key":1})]));
}

ArrowRightInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
